import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    isDarkMode: false,
    isTransitioning: false
  }),

  actions: {



    // ------------------------------------------------- //
    //                                                   //
    //                                                   //
    //  Theme Toggle & Apply                             //
    //                                                   //
    //                                                   //
    // ------------------------------------------------- //

    toggleTheme() {
      this.isDarkMode = !this.isDarkMode
      this.applyTheme()
    },

    applyTheme() {

      
      this.isTransitioning = true
      
      document.documentElement.classList.toggle('dark-theme', this.isDarkMode)
      
      const metaThemeColor = document.querySelector('meta[name="theme-color"]')
      if (metaThemeColor) {
        metaThemeColor.setAttribute('content', this.isDarkMode ? '#24262E' : '#FFFFFF')
      }
      
      // Save preference
      localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light')
      
      // Clear transitioning state quickly (only for switch UI)
      setTimeout(() => {
        this.isTransitioning = false
      }, 100)
    },


    // ------------------------------------------------- //
    //                                                   //
    //                                                   //
    //  Theme Initialization                             //
    //                                                   //
    //                                                   //
    // ------------------------------------------------- //

    initTheme() {
      const savedTheme = localStorage.getItem('theme')
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      
      // Set initial state
      this.isDarkMode = savedTheme ? savedTheme === 'dark' : prefersDark
      
      // Apply theme without ANY delays for initial load
      document.documentElement.classList.add('theme-loading')
      document.documentElement.classList.toggle('dark-theme', this.isDarkMode)
      
      // Add meta theme-color if it doesn't exist
      if (!document.querySelector('meta[name="theme-color"]')) {
        const meta = document.createElement('meta')
        meta.name = 'theme-color'
        meta.content = this.isDarkMode ? '#24262E' : '#FFFFFF'
        document.head.appendChild(meta)
      }
      
      // Remove loading class immediately
      document.documentElement.classList.remove('theme-loading')
      
      // Listen for system theme changes
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        if (!localStorage.getItem('theme')) {
          this.isDarkMode = e.matches
          this.applyTheme()
        }
      })
    }
  }
}) 